<template>
  <div>
    <SiruiSearch
      ref="formItem"
      :query="query"
      :columns="fromColumns"
      :isQueryPanel="true"
      :defaultRow="2"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :data="tableData"
        :buttonList="menuButtonList"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="tableColumn"
        :showToolbar="true"
        show-footer
        :valid-config="{ autoPos: true, message: 'inline' }"
        :loading="load"
        :footer-method="footerMethod"
        @dblclickEvent="dblclickEvent"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>

        <template>
          <vxe-table-column
            :key="index"
            v-for="(i, index) in tableColumn"
            :title="i.title"
            :field="i?.field"
            :type="i?.type"
            :formatter="i?.formatter"
            align="center"
          >
            <template v-if="i.children">
              <vxe-table-column
                :key="index"
                v-for="(item, index) in i.children"
                :title="item.title"
                :field="item.field"
                :formatter="i?.formatter"
                align="center"
              >
              </vxe-table-column>
            </template>
          </vxe-table-column>
        </template>
      </sirui-table>
    </div>
    <AddDialog :visible.sync="addDialogVisible" :detail="checkedRow" @refresh="searchBtnClick" />
  </div>
</template>

<script>
  import DataBaseAPI from '@/api/dataBase';
  import { formColumn, defaultTableColumn } from './index.js';
  import { filterEmpty } from '@/common/js/util';
  import { formatDate } from '@/utils';
  import AddDialog from './addDialog.vue';
  export default {
    name: 'liquidatedDamages',
    props: [],
    data() {
      return {
        tableData: [],
        load: false,
        query: {
          contractBusinessDepartment: null,
        },
        departmentList: [],
        menuButtonList: [],
        footerTotalCols: {
          amount: [
            'invoiceAmount',
            'allocationAmount',
            'accumulateOverdueAmount',
            'remainUnpaidAmount',
            'liquidatedAmountDailyRate',
            'liquidatedAmountFixed',
          ],
          quantity: [],
        },
        addDialogVisible: false,
        checkedRow: null,
      };
    },
    computed: {
      tableColumn() {
        return defaultTableColumn(this);
      },
      fromColumns() {
        return formColumn(this);
      },
    },
    mounted() {
      this.getButtonList();

      this.getTableData();
      //   this.getDepartment(this.userInfo.companyCode);
      //   this.$refs.siruiTable.setPageNum(1);
      //   this.$refs.siruiTable.setPageSize(10);
      //   this.query.contractBusinessDepartment = this.userInfo.departmentCode;
    },
    methods: {
      formatterNum({ cellValue }) {
        if (!cellValue) return null;
        return this.$utils.commafy(this.$utils.toNumber(cellValue), { digits: 2 });
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            for (let key in this.footerTotalCols) {
              if (this.footerTotalCols[key].includes(column.property)) {
                let total = this.$utils.calSum(data, column.property);
                let point = this.$globalVar.aPoint;
                if (key == 'quantity') {
                  point = this.$globalVar.qPoint;
                }
                total = this.$utils.commafy(this.$utils.toNumber(total), { digits: point });
                return total;
              }
            }
            return null;
          }),
        ];
      },
      // 表单中的数据切换
      async changeMethod({ prop, val }) {
        console.log(prop, val, '修改');
        if (prop == 'projectInitiationNo') {
          this.query.projectInitiationNo = val[0].projectInitiationNo;
          this.query.projectName = val[0].projectName;
        } else if (prop == 'contractNoLike') {
          this.query.contractNoLike = val[0].contractNo;
        } else if (prop == 'customerNo') {
          console.log('val', val);
          let item = val[0];
          if (item) {
            this.query.customerNo = item.partnerCode;
          }
        } else if (prop == 'platformCompanyCode') {
          this.query.contractBusinessDepartment = null;
          if (val) {
            this.getDepartment(val);
          } else {
            this.departmentList = [];
          }
        }
      },
      resetBtnClick() {
        // this.resetQuery();
        this.getTableData();
      },
      searchBtnClick() {
        this.getTableData();
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          // this.getColumnInfo();
        });
      },
      chooseClick(type) {
        try {
          console.log(type);
          this[type]();
        } catch (e) {
          console.error('当前方法不支持', e);
          this.$message.error(`${type}当前方法不支持,请联系开发人员`);
        }
      },
      add() {
        this.addDialogVisible = true;
        this.checkedRow = null;
      },
      dblclickEvent({ row }) {
        if (row.isManual) {
          this.checkedRow = row;
          this.addDialogVisible = true;
        } else {
          this.$message.error('只能修改手动录入数据');
        }
      },
      // 搜索按钮
      searchTrigger() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },

      async exportExcel() {
        // this.query.contractBusinessDepartment = '';
        const { data } = await this.$axios.post(
          '/financial/statistic/overdue/exportOverdue',
          this.query
        );
        if (data.code === 0) {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success',
          });
          // console.log(data.data);
          window.location.href = data.data.word;
        } else {
          this.$alert(data.msg);
        }
        console.log('导出');
      },
      handleSizeChange() {
        this.getTableData();
      },
      handleCurrentChange() {
        this.getTableData();
      },

      // footerMethod({ columns }) {
      //   return [
      //     columns.map((column, columnIndex) => {
      //       // if (columnIndex === 0) {
      //       //   return '合计';
      //       // }
      //       // console.log(column.property);

      //       return null;
      //     }),
      //   ];
      // },
      async getDepartment(companyCode) {
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const { data } = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (data.code == 0) {
            this.departmentList = data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      async getTableData() {
        let params = { ...this.query };
        params.pageSize = this.$refs.siruiTable.page.pageSize;
        params.pageNum = this.$refs.siruiTable.page.pageNum;
        let { data } = await this.$axios.post(
          '/financial/statistic/overdue/page',
          filterEmpty(params)
        );

        if (data.code == 0) {
          let info = data.data.records;
          if (this.$refs.siruiTable) {
            this.$refs.siruiTable.setPageTotal(data.data.total);
          }
          let result = [];
          if (info.length != 0) {
            info.forEach((item) => {
              // console.log("item1",item)
              if (item.invoiceInfoList && item.invoiceInfoList.length != 0) {
                item.invoiceInfoList.forEach((invoice) => {
                  console.log('item2', invoice);
                  invoice = {
                    ...invoice,
                    ...item,
                    rate: invoice.rate ? invoice.rate + '%' : '100%',
                    actualCollectionDate: invoice.actualCollectionDate
                      ? formatDate(invoice.actualCollectionDate, true)
                      : '',
                    rateAmount: invoice.rate
                      ? this.$cal.calCommon(
                          this.$cal.calCommon(invoice.rate, invoice.invoiceAmount, '*'),
                          100,
                          '/',
                          2
                        )
                      : invoice.invoiceAmount,
                  };

                  // let combined = Object.assign(item, invoice);
                  // result.push(combined);
                  // console.log("item3",invoice)
                  result.push(invoice);
                });
              } else {
                result.push({ ...item, rate: '100%', actualCollectionDate: '' });
              }
            });
          }
          this.tableData = result;
        }
      },
    },
    components: { AddDialog },
    watch: {},
  };
</script>

<style lang="scss" scoped></style>
